export default "__VITE_ASSET__b45cdb33__"